import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SmoothLink, Sticky } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';

const styles = css`
`;

function DetailMenu({ home, community }) {
  return (
    <Sticky style={{ zIndex: 100, top: 0 }} className={styles}>
      <div className="DetailMenu">
        <div className="container">
          <ul className="DetailMenu_list">
            <li className="DetailMenu_listItem"><SmoothLink href="#overview">Overview</SmoothLink></li>
            {
              get(home, 'description') &&
              <li className="DetailMenu_listItem"><SmoothLink href="#description">Description</SmoothLink></li>
            }
            {
              get(home, 'floorplanPhotos', []).length > 0 &&
              <li className="DetailMenu_listItem"><SmoothLink href="#plan">Floor Plan</SmoothLink></li>
            }
            {
              get(home, 'photos', []).length > 0 &&
              <li className="DetailMenu_listItem"><SmoothLink href="#photos">Photo Gallery</SmoothLink></li>
            }
            <li className="DetailMenu_listItem"><SmoothLink href="#specifications">Specifications</SmoothLink></li>
            {
              get(community, 'schools', []).length > 0 &&
              <li className="DetailMenu_listItem"><SmoothLink href="#schools">Schools</SmoothLink></li>
            }
            <li className="DetailMenu_listItem"><SmoothLink href="#map">Map & Directions</SmoothLink></li>
          </ul>
        </div>
      </div>
    </Sticky>
  );
}

DetailMenu.propTypes = {
  home: PropTypes.object.isRequired,
  community: PropTypes.object,
};

DetailMenu.defaultProps = {
  community: undefined,
};

export default withData(
  {
    home: true,
    community: true,
  },
  {
    required: {
      home: true,
    },
  },
)(DetailMenu);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/DetailMenu.js